import moment from 'moment';
import _ from 'lodash';

export const findNextSession = (sessions: any[]) => {
  const now = moment(Date.now());
  const possibleSessions = sessions.filter(session =>
    moment(session.eventStart).add(session.duration, 'minutes').isAfter(now),
  );
  return possibleSessions.length > 0 ? possibleSessions[0] : null;
};

export const findAllFutureSessions = (sessions: any[]) => {
  const now = moment(Date.now());
  return sessions
    .filter(session => !session.canceled)
    .filter(session => moment(session.eventStart).isAfter(now));
};

export const formatCollections = (collections: any, currentUserId: string) => {
  return Object.values(collections)
    .map((c: unknown) => ({
      ...(c as any[])[0],
      rsvpUsers: _.uniq(_.flatten((c as any[]).map((s: any) => s.rsvpUsers))),
      attendees: _.uniq(_.flatten((c as any[]).map((s: any) => s.attendees))),
      invitedUsers: _.uniq(_.flatten((c as any[]).map((s: any) => s.invitedUsers))),
      invitedWorkerTeams: _.uniq(_.flatten((c as any[]).map((s: any) => s.invitedWorkerTeams))),
      invitedQualifications: _.uniq(
        _.flatten((c as any[]).map((s: any) => s.invitedQualifications)),
      ),
      invitedSquads: _.uniq(_.flatten((c as any[]).map((s: any) => s.invitedSquads))),
      zoomAttendees: _.uniq(_.flatten((c as any[]).map((s: any) => s.zoomAttendees ?? []))),
      occurrences: (c as any[]).map((s: any) => s.eventStart),
      sessions: c as any[],
      currentUserId,
    }))
    .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
};

export const filterElapsedSessions = (collections: any, currentUserId: string) => {
  const now = new Date();
  return Object.values(collections)
    .map((c: unknown) => (c as any[]).filter((s: any) => new Date(s.eventStart) > now))
    .filter((c: any[]) => c.length > 0)
    .map((c: any[]) => ({
      ...c[0],
      sessionCollection: c[0]._id,
      rsvpUsers: _.uniq(_.flatten(c.map((s: any) => s.rsvpUsers))),
      attendees: _.uniq(_.flatten(c.map((s: any) => s.attendees))),
      invitedUsers: _.uniq(_.flatten((c as any[]).map((s: any) => s.invitedUsers))),
      invitedWorkerTeams: _.uniq(_.flatten((c as any[]).map((s: any) => s.invitedWorkerTeams))),
      invitedQualifications: _.uniq(
        _.flatten((c as any[]).map((s: any) => s.invitedQualifications)),
      ),
      invitedSquads: _.uniq(_.flatten((c as any[]).map((s: any) => s.invitedSquads))),
      zoomAttendees: _.uniq(_.flatten(c.map((s: any) => s.zoomAttendees ?? []))),
      occurrences: c.map((s: any) => s.eventStart),
      sessions: c as any[],
      currentUserId,
    }))
    .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
};

export const contructGCalLink = (session: any) => {
  const title = encodeURIComponent(session.name);
  const startDate =
    moment(session.eventStart).toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
  const endDate =
    moment(session.eventStart)
      .add(session.duration, 'minutes')
      .toISOString()
      .replace(/[-:]/g, '')
      .split('.')[0] + 'Z';
  const description = encodeURIComponent(
    `${session.description}\n\nZoom Join Link: ${session.zoomMeeting.joinUrl} `,
  );
  return `http://www.google.com/calendar/render?action=TEMPLATE&text=${title}&dates=${startDate}/${endDate}&details=${description}&trp=false&sprop=&sprop=name:`;
};

export const formatSessionDate = (date: string) => {
  const tz = moment.tz.guess();
  return moment(date).tz(tz).format('dddd MMM D, YYYY h[:]mmA z');
};

export const isPastSession = (session: { eventStart: string; duration: number }) => {
  return moment(session.eventStart).add(session.duration, 'minutes').isBefore(moment());
};

export const formatDurationSeconds = (seconds: number): string => {
  const minutes = Math.floor(seconds / 60);
  let s = '';
  if (minutes % 60 > 0) s += `${minutes % 60} min`;
  if (Math.floor(minutes / 60) === 1) s = `${Math.floor(minutes / 60)} hour ` + s;
  else if (Math.floor(minutes / 60) > 0) s = `${Math.floor(minutes / 60)} hours ` + s;
  return s;
};
